import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoteMapMarkerComponent } from './mote-map-marker.component';
import { OfflineModule } from '../../offline/offline.module';
import { ClickOutsideDirectiveModule } from '../../directives';



@NgModule({
    declarations: [
        MoteMapMarkerComponent
    ],
    imports: [
        CommonModule,
        OfflineModule,
        ClickOutsideDirectiveModule
    ],
    exports: [
        MoteMapMarkerComponent
    ]
})
export class MoteMapMarkerModule { }
